<template>
  <div>
    <v-row>
      <v-col>
        <v-select
            label="Type de poster"
            v-model="recordObject.extravars.posterDisplay"
            :items="[
                  {
                    text:'Normal',
                    value:'poster-marge',
                  },
                  {
                    text:'Pleine largeur',
                    value:'poster-full-width',
                  },
                  {
                    text:'Home',
                    value:'poster-home',
                  },
              ]"
        />
      </v-col>
      <v-col>
        <v-switch
            v-if="formationsPossible"
            dense
            label="Menu formations"
            v-model="recordObject.extravars.posterMenuFormations"
        />
      </v-col>
    </v-row>
    <v-textarea
        label="Texte du poster"
        filled auto-grow
        v-if="notificationsPossible"
        v-model="recordObject.extravars.posterText"
    />
    <div v-if="notificationsPossible">
      <field-label>Notifications du poster</field-label>
      <notifications-block-edit
          :block="recordObject.moredata.getByName('posterNotifications')"/>
    </div>

</div>
</template>

<script>
import FieldLabel from "@/ee09/db-ui/fields/field-label";
import NotificationsBlockEdit from "@/Models/blocks/links/notifications/notifications-block-edit";
import RecordEditMixin from "@/ee09/db-ui/records/RecordEditMixin";
import PosterOptionsMixin from "@/Models/edit-shared/PosterOptionsMixin";
export default {
  name: "poster-options",
  components: {NotificationsBlockEdit, FieldLabel},
  mixins:[RecordEditMixin,PosterOptionsMixin],
  computed:{
    /**
     *
     * @return {PageModel}
     */
    recordObject(){
      return this.record;
    }

  }
}
</script>

<style scoped>

</style>